import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Get In Touch
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Interested in collaboration or have questions? We'd love to hear from you.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Contact Information
              </h3>
              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div className="flex items-start group bg-white p-6 rounded-xl shadow-lg">
                  <div className="bg-emerald-100 p-3 rounded-lg group-hover:bg-emerald-600 transition-colors duration-300">
                    <Mail className="h-6 w-6 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold text-slate-900 mb-1">Email</h4>
                    <a 
                      href={`mailto:${contactInfo.email}`}
                      className="text-slate-600 hover:text-emerald-600 transition-colors"
                    >
                      {contactInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start group bg-white p-6 rounded-xl shadow-lg">
                  <div className="bg-emerald-100 p-3 rounded-lg group-hover:bg-emerald-600 transition-colors duration-300">
                    <MapPin className="h-6 w-6 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold text-slate-900 mb-1">Address</h4>
                    <p className="text-slate-600">
                      {contactInfo.address}<br />
                      {contactInfo.city}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="bg-slate-200 rounded-xl h-96 overflow-hidden shadow-lg">
              <iframe
                title="UC Riverside Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.0867794447845!2d-117.32860968478394!3d33.97544098062883!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcae6bdb6a8b35%3A0x8c82b9fa29c2e65!2sUniversity%20of%20California%2C%20Riverside!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
